import UserAnswer from "model/UserAnswer";

const parseUserAnswers = (selectedAnswers: Map<number, number>): UserAnswer[] => {
    return Array.from(selectedAnswers).map(([key, value]): UserAnswer => ({
        questionId: key,
        answerId: value
    }))
}

export default parseUserAnswers;